import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Navigation = () => {
  const { t } = useTranslation();
  return (
    <ul className="flex flex-col gap-y-3 text-white uppercase">
      <Link className="hover:underline" to={"/"}>
        {t("nav_home")}
      </Link>
      <Link className="hover:underline" to={"/about-us"}>
        {t("nav_about")}
      </Link>
      <Link className="hover:underline" to={"/clients"}>
        {t("nav_partner")}
      </Link>
      <Link className="hover:underline" to={"/resources"}>
        {t("nav_resources")}
      </Link>
      {/* <Link className="hover:underline" to={"/clients"}>
        {t("nav_clients")}
      </Link> */}
      <Link className="hover:underline" to={"/projects"}>
        {t("nav_projects")}
      </Link>
      <Link className="hover:underline" to={"/certificates"}>
        {t("nav_certificates")}
      </Link>
      <Link className="hover:underline" to={"/contact-us"}>
        {t("nav_contact")}
      </Link>
      <a className="hover:underline" href="mailto:solutions@iasco.sa">
        {t("nav_join_us")}
      </a>
    </ul>
  );
};

export default Navigation;
